import { FiEdit2, FiCheck } from 'react-icons/fi';
import Badge from '../../../../components/ui/Badge';

/**
 * Workshop equipment card: no Quick Pass — full checklist required in modal.
 * Single "Inspect" button when untested; Pass/Fail badge + Edit when tested.
 */
export function WorkshopCard({
  asset,
  sessionEntry,
  onEdit,
  isSyncing,
}) {
  const tested = sessionEntry != null;
  const sessionStatus = sessionEntry?.status ?? 'pass';
  const isSynced = sessionEntry?.synced ?? false;

  return (
    <div className="asset-card-actions">
      {tested && (
        <>
          {sessionStatus === 'fail' ? (
            <Badge variant="danger">Failed</Badge>
          ) : (
            <Badge variant="success">Passed</Badge>
          )}
          {isSynced ? (
            <span className="sync-saved" title="Saved to server">
              <FiCheck size={14} aria-hidden />
            </span>
          ) : (
            <Badge variant="warning" className="sync-pending">Saving…</Badge>
          )}
          <button
            type="button"
            className="btn btn-sm btn-icon"
            onClick={(e) => {
              e.stopPropagation();
              onEdit(asset, sessionEntry);
            }}
            title="Edit result"
            aria-label="Edit result"
          >
            <FiEdit2 size={16} />
          </button>
        </>
      )}
      {!tested && (
        <button
          type="button"
          className="btn btn-sm btn-primary"
          onClick={() => onEdit(asset)}
          disabled={isSyncing}
          title="Complete inspection checklist"
        >
          Inspect
        </button>
      )}
    </div>
  );
}
